var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 11.3327H10.8334V15.4993C10.8334 15.9577 10.4584 16.3327 10.0001 16.3327C9.54175 16.3327 9.16675 15.9577 9.16675 15.4993V11.3327H5.00008C4.54175 11.3327 4.16675 10.9577 4.16675 10.4993C4.16675 10.041 4.54175 9.66602 5.00008 9.66602H9.16675V5.49935C9.16675 5.04102 9.54175 4.66602 10.0001 4.66602C10.4584 4.66602 10.8334 5.04102 10.8334 5.49935V9.66602H15.0001C15.4584 9.66602 15.8334 10.041 15.8334 10.4993C15.8334 10.9577 15.4584 11.3327 15.0001 11.3327Z",
    fill: "#F8F8F8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.9511d4814c974a806a30fd8939ecf1ff.svg";
export { ForwardRef as ReactComponent };